import {Component, Input} from '@angular/core';
import {MatCardModule} from "@angular/material/card";
import {NgOptimizedImage} from "@angular/common";

@Component({
  selector: 'app-banner-logo',
  imports: [
    MatCardModule,
    NgOptimizedImage,
  ],
  templateUrl: './banner-logo.component.html',
  styleUrl: './banner-logo.component.scss'
})
export class BannerLogoComponent {
}
